import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierForecastCreationStatusIcon',
  props: {
    isCreated: { type: Boolean, default: false }
  },
  setup(__props: any) {

const t = i18n.t;

const props = __props;

const computedClass = computed(() => {
  return props.isCreated ? 'creation-status--created' : 'creation-status--not-created';
});

const displayText = computed(() => {
  return props.isCreated ? t('仕入先内示作成ステータス:完了') : t('仕入先内示作成ステータス:未完了');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["creation-status", computedClass.value])
  }, _toDisplayString(displayText.value), 3))
}
}

})